import React from "react";

import {
  LinearProgress,
  linearProgressClasses,
  LinearProgressProps,
  useTheme,
} from "@mui/material";

export const IgLinearProgress = ({ sx, ...props }: LinearProgressProps) => {
  const theme = useTheme();

  return (
    <LinearProgress
      sx={{
        ...sx,
      }}
      {...props}
    />
  );
};
